import { render, staticRenderFns } from "./PDFInstead.vue?vue&type=template&id=44f6537f&"
import script from "./PDFInstead.vue?vue&type=script&lang=ts&"
export * from "./PDFInstead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports